import { FC } from "react";

import LogoImg from "assets/images/logo/logo.png";

interface FooterI {
	description: string;
	imgAlt: string;
	navigation: any;
}

const date: Date = new Date()
const thisYear: number = date.getFullYear()

export const Footer: FC<FooterI> = ({ description, imgAlt, navigation }) => {
	return (
		<footer className='bg-white' aria-labelledby='footer-heading'>
			<h2 id='footer-heading' className='sr-only'>
				Footer
			</h2>
			<div className='mx-auto max-w-7xl py-12 px-4 sm:px-6 lg:py-16 lg:px-8'>
				<div className='xl:grid xl:grid-cols-3 xl:gap-8'>
					<div className='space-y-8 xl:col-span-1'>
						<img className='h-10' src={LogoImg} alt={imgAlt} />
						<p className='text-base text-gray-500'>{description}</p>
						<div className='flex space-x-6'>
							{navigation.social.map((item: any) => (
								<a
									key={item.name}
									href={item.href}
									className='text-gray-400 hover:text-gray-500'
								>
									<span className='sr-only'>{item.name}</span>
									<item.icon className='h-6 w-6' aria-hidden='true' />
								</a>
							))}
						</div>
					</div>
					<div className='mt-12 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0'>
						<div className='md:grid md:grid-cols-2 md:gap-8'>
							<div>
								<h3 className='text-base font-medium text-gray-900'>
									Solutions
								</h3>
								<ul className='mt-4 space-y-4'>
									{navigation.solutions.map((item: any) => (
										<li key={item.name}>
											<a
												href={item.href}
												className='text-base text-gray-500 hover:text-gray-900'
											>
												{item.name}
											</a>
										</li>
									))}
								</ul>
							</div>
							<div className='mt-12 md:mt-0'>
								<h3 className='text-base font-medium text-gray-900'>Support</h3>
								<ul className='mt-4 space-y-4'>
									{navigation.otherLinks.map((item: any) => (
										<li key={item.name}>
											<a
												href={item.href}
												className='text-base text-gray-500 hover:text-gray-900'
											>
												{item.name}
											</a>
										</li>
									))}
								</ul>
							</div>
						</div>
						<div className='md:grid md:grid-cols-2 md:gap-8'>
							<div>
								<h3 className='text-base font-medium text-gray-900'>Company</h3>
								<ul className='mt-4 space-y-4'>
									{navigation.company.map((item: any) => (
										<li key={item.name}>
											<a
												href={item.href}
												className='text-base text-gray-500 hover:text-gray-900'
											>
												{item.name}
											</a>
										</li>
									))}
								</ul>
							</div>
							<div className='mt-12 md:mt-0'>
								<h3 className='text-base font-medium text-gray-900'>Legal</h3>
								<ul className='mt-4 space-y-4'>
									{navigation.legal.map((item: any) => (
										<li key={item.name}>
											<a
												href={item.href}
												className='text-base text-gray-500 hover:text-gray-900'
											>
												{item.name}
											</a>
										</li>
									))}
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className='mt-12 border-t border-gray-200 pt-8'>
					<p className='text-base text-gray-400 xl:text-center'>
						&copy; {thisYear} View Limited. All rights reserved.
					</p>
				</div>
			</div>
		</footer>
	);
};
